import routerOptions0 from "/codebuild/output/src3925525253/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@22.15.3_db0@0.3.2_eslint@8.57.1_ioredis@5_330e93cf17718db3ff392860e1ede7ab/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}